import React, { Suspense } from 'react';

// A component whose code loads on first render, in its own chunk, behind its own Suspense so
// call sites render it like any other component. A failed load (most often: a deploy replaced
// the chunk under a tab opened before it) shows a reload prompt instead of breaking the page.
export function lazyView(load, fallback = null) {
  const Lazy = React.lazy(() => load().catch(() => ({ default: StaleChunk })));
  function LazyView(props) {
    return (
      <Suspense fallback={fallback}>
        <Lazy {...props} />
      </Suspense>
    );
  }
  return LazyView;
}

function StaleChunk() {
  return (
    <div role="alert" style={{ padding: 16, fontSize: 14 }}>
      Ave Q was updated.{' '}
      <button type="button" onClick={() => window.location.reload()}>Reload</button>
      {' '}to see this.
    </div>
  );
}
